import styled from 'styled-components';
import { colors, fontSizes, spacing, zIndex } from 'ui/theme';

export const DashedSpan = styled.span`
  text-decoration: underline;
  text-decoration-style: dashed;
  text-underline-offset: ${spacing.eighth};
  color: ${colors.grey50};
  display: flex;
  font-size: ${fontSizes.s12};
`;

export const StyledContainer = styled.div`
  display: flex;
  z-index: ${zIndex.popover};
`;

export const StyledList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const StyledItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${spacing.double};
  justify-content: space-between;
`;

export const FlagSpan = styled.span`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter}; 
`;

export const PopoverSpan = styled.span`
  color: ${colors.textPrimary}; 
  font-size: ${fontSizes.s14};
`;
